import {Injectable, isDevMode} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import * as io from 'socket.io-client';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SocketService {
    private host: string;
    private socket: any;

    public progressMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('Parsing...');
    public resultLink$: BehaviorSubject<string> = new BehaviorSubject<string>('');

    constructor() {
        if (isDevMode()) {
            this.host = window.location.protocol + '//' + window.location.hostname + ':' + 5000 + '/socket.io/';
        } else {
            this.host = window.location.protocol + '//' + window.location.hostname  + '/socket.io/';
        }
    }

    connect1 (taskID: string): Observable<string> {
        return Observable.create(observer => {
            this.socket = io(this.host)

            this.socket.on('connect', () => {
                this.socket.on('task_' + taskID + '_', (results: string) => {
                    observer.next(results);
                });

                this.socket.on('task_' + taskID + '_error', (err: string) => {
                    observer.error(err);
                });

                this.socket.on('task_' + taskID + '_info', (msg: string) => {
                    this.progressMessage$.next(msg);
                });

                this.socket.on('task_' + taskID + '_finish', (parseResult) => {
                    this.socket.disconnect();
                    this.resultLink$.next(parseResult);
                    // observer.complete();
                });
                this.socket.emit('init', taskID);
            });

            this.socket.on('error', (err: string) => {
                observer.error(err);
            })

            this.socket.on('disconnect', () => {
                console.log('disconnected');
                observer.complete();
            })
        });
    }

    connect () {
        this.socket = io(this.host);
        this.socket.on('connect', () => this.connected());
        this.socket.on('disconnect', () => this.disconnected());
        this.socket.on('error', (error: string) => {
            console.log(`ERROR: "${error}" (${this.host})`);
        });
        this.socket.connect();
    }

    disconnect () {
        this.socket.disconnect();
    }

    emit(chanel, message) {
        return new Observable<any>(observer => {
            console.log(`emit to ${chanel}:`, message);
            this.socket.emit(chanel, message, function (data) {
                if (data.success) {
                    observer.next(data.msg);
                } else {
                    observer.error(data.msg);
                }
                observer.complete();
            });
        });
    }

    on(event_name) {
        console.log(`listen to ${event_name}:`);
        return new Observable<any>(observer => {
            this.socket.off(event_name);
            this.socket.on(event_name, (data) => {
                observer.next(data);
            });
        });
    }

    private connected() {
        console.log('Connected');
    }

    private disconnected() {
        console.log('Disconnected');
    }
}
